import { useCallback, useEffect, useState } from 'react'
import { useToasts } from 'react-toast-notifications'
import campaignApi from 'services/api/campaign'

export default function useCampaignCredits() {
  const [credits, setCredits] = useState(0)
  const [isLoading, setIsLoading] = useState(true)
  const { addToast } = useToasts()

  const fetchCredits = useCallback(() => {
    setIsLoading(true)
    campaignApi
      .getCampaignCredit()
      .then(setCredits)
      .catch(error => addToast(`${error}`, { appearance: 'error', autoDismiss: true }))
      .finally(() => setIsLoading(false))
  }, [addToast])

  useEffect(() => {
    fetchCredits()
  }, [fetchCredits])

  return { credits, isLoading, refetch: fetchCredits }
}
